<tui-tabs [activeItemIndex]="activeTabIndex()" (activeItemIndexChange)="selectTab($event)">
  @for (tab of tabs(); track tab.id) {
    <button tuiTab type="button">{{ tab.label }}</button>
  }
</tui-tabs>

@if (activeTab() === 'users') {
  <app-settings-user-list (add)="addUser.emit()" (edit)="editUser.emit($event)" />
} @else {
  <app-settings-role-list
    (add)="addRole.emit()"
    (edit)="editRole.emit($event)"
    (copy)="copyRole.emit($event)"
  />
}
